var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['form-error-popup', _vm.customClass]},[_vm._t("default"),(_vm.closable)?_c('button',{on:{"click":function($event){return _vm.$emit('close')}}},[_c('CloseIcon',{staticClass:"close-icon"})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }